import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  I2gNgTrackingActionBuilder,
  I2gNgTrackingService,
  ITrackingAction,
  ITrackingObject,
} from 'i2g-ng-tracking';

type NotificationStyle = 'success' | 'info' | 'alert';

enum NotificationIconsEnum {
  success = 'success',
  info = 'info',
  alert = 'alert',
}

@Component({
  selector: 'i2g-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent implements OnInit {
  @Input() showButton = false;
  @Input() showDismissIcon = true;
  @Input() notificationStyle: NotificationStyle = 'info';
  @Input() message: string;
  @Input() isHtmlMessage = false;
  @Input() buttonText: string;
  @Input() trackingObject: ITrackingObject;
  @Input() buttonTrackingAction: ITrackingAction;
  @Input() dismissTrackingAction: ITrackingAction;
  @Input() trackingScreenName: string;

  @Output() dismiss: EventEmitter<void> = new EventEmitter<void>();
  @Output() clickButton: EventEmitter<void> = new EventEmitter<void>();

  NotificationIconsEnum = NotificationIconsEnum;

  constructor(
    private _trackingService: I2gNgTrackingService,
    private _trackingActionBuider: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    if (this.trackingObject && this.trackingScreenName) {
      this._trackingService.trackEvent(
        this.trackingObject,
        this._trackingActionBuider.buildPresented(this.trackingScreenName)
      );
    }
  }
}
